import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Footer } from "@/components/landing/Footer";

export const LegalPageLayout = ({ title, eyebrow, children }) => {
  useEffect(() => {
    window.lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, []);

  return (
  <div className="bg-baseLight min-h-screen">
    <header className="px-4 sm:px-6 pt-6 pb-4">
      <div className="max-w-[760px] mx-auto flex items-center justify-between">
        <Link to="/" data-testid="legal-logo-link" className="font-heading font-semibold text-lg tracking-tight text-ink">
          Off-Grid Hydrogen
        </Link>
        <Link
          to="/"
          data-testid="legal-back-link"
          className="flex items-center gap-1.5 text-sm text-inkSoft hover:text-teal transition-colors duration-300"
        >
          <ArrowLeft size={15} /> Back to home
        </Link>
      </div>
    </header>

    <main className="px-4 sm:px-6 py-14 lg:py-20">
      <div className="max-w-[760px] mx-auto">
        <span className="text-sm font-medium text-teal">{eyebrow}</span>
        <h1 data-testid="legal-page-title" className="font-heading text-3xl sm:text-4xl font-semibold text-ink mt-3 leading-tight">
          {title}
        </h1>
        <p className="text-sm text-inkMuted mt-4">Last updated: September 2026</p>

        <div className="mt-12 space-y-10">{children}</div>
      </div>
    </main>

    <Footer />
  </div>
  );
};

export const LegalSection = ({ heading, children, testid }) => (
  <section data-testid={testid}>
    <h2 className="font-heading text-xl font-semibold text-ink mb-3">{heading}</h2>
    <div className="text-inkSoft leading-relaxed text-[15px] space-y-4">{children}</div>
  </section>
);
